// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estrutura principal com plano de fundo em gradiente */
.Crentes_container__\\+PPM0 {
    display: flex;
    flex-direction: row;
    height: 100vh;
    background: linear-gradient(135deg, #074273 0%, #00a0e4 100%);
    position: relative;
    overflow: hidden;
}

/* Barra lateral com design moderno */
.Crentes_sidebar__0HsK1 {
    margin-top: 100px;
    width: 30%;
    background: rgba(255, 255, 255, 0.8);
    padding: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    overflow-y: auto;
    z-index: 2;
}

/* Caixa de pesquisa estilizada */
.Crentes_searchBar__tJZ9H {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
}

.Crentes_searchBar__tJZ9H input {
    flex: 1 1;
    padding: 10px;
    margin-right: 10px;
    border-radius: 30px;
    border: none;
    background: #f9f9f9;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.Crentes_searchBar__tJZ9H input:focus {
    background: #fff;
    box-shadow: 0 0 8px rgba(0, 160, 228, 0.4);
}

.Crentes_addButton__4xJ-H {
    padding: 10px 20px;
    background-color: #f59c11;
    color: white;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.Crentes_addButton__4xJ-H:hover {
    background-color: #e6392f;
}

ul {
    list-style-type: none;
    padding: 0;
}

ul li {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    transition: background 0.3s ease, transform 0.2s ease;
}

.Crentes_crentesList__WAVtc li:hover,
.Crentes_activeCrente__fL6R1 {
    background-color: rgba(0, 160, 228, 0.1);
    font-weight: bold;
    transform: scale(1.05);
}

.Crentes_details__tp32m {
    margin-top: 70px;
    width: 70%;
    padding: 20px;
}

@media (max-width: 768px) {
      
    .Crentes_sidebar__0HsK1 h1 {
        text-align: center;
    }
}

`, "",{"version":3,"sources":["webpack://./src/pages/LIFTrac/crentes/Crentes.module.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,iBAAiB;IACjB,UAAU;IACV,oCAAoC;IACpC,aAAa;IACb,0CAA0C;IAC1C,mCAA2B;YAA3B,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;AACd;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;;IAEI,wCAAwC;IACxC,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;;AAEA;;IAEI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Estrutura principal com plano de fundo em gradiente */\r\n.container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100vh;\r\n    background: linear-gradient(135deg, #074273 0%, #00a0e4 100%);\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n/* Barra lateral com design moderno */\r\n.sidebar {\r\n    margin-top: 100px;\r\n    width: 30%;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    padding: 20px;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n    backdrop-filter: blur(10px);\r\n    overflow-y: auto;\r\n    z-index: 2;\r\n}\r\n\r\n/* Caixa de pesquisa estilizada */\r\n.searchBar {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n}\r\n\r\n.searchBar input {\r\n    flex: 1;\r\n    padding: 10px;\r\n    margin-right: 10px;\r\n    border-radius: 30px;\r\n    border: none;\r\n    background: #f9f9f9;\r\n    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.searchBar input:focus {\r\n    background: #fff;\r\n    box-shadow: 0 0 8px rgba(0, 160, 228, 0.4);\r\n}\r\n\r\n.addButton {\r\n    padding: 10px 20px;\r\n    background-color: #f59c11;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 30px;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.addButton:hover {\r\n    background-color: #e6392f;\r\n}\r\n\r\nul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n}\r\n\r\nul li {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n    transition: background 0.3s ease, transform 0.2s ease;\r\n}\r\n\r\n.crentesList li:hover,\r\n.activeCrente {\r\n    background-color: rgba(0, 160, 228, 0.1);\r\n    font-weight: bold;\r\n    transform: scale(1.05);\r\n}\r\n\r\n.details {\r\n    margin-top: 70px;\r\n    width: 70%;\r\n    padding: 20px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n      \r\n    .sidebar h1 {\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Crentes_container__+PPM0`,
	"sidebar": `Crentes_sidebar__0HsK1`,
	"searchBar": `Crentes_searchBar__tJZ9H`,
	"addButton": `Crentes_addButton__4xJ-H`,
	"crentesList": `Crentes_crentesList__WAVtc`,
	"activeCrente": `Crentes_activeCrente__fL6R1`,
	"details": `Crentes_details__tp32m`
};
export default ___CSS_LOADER_EXPORT___;
